import { createApp } from 'vue';
import { isInHospEnv } from './services/base';
import initAppConfig, { AppKeyConf as IAppConf } from './appConfig';
import App from './App.vue';
import router from './router';
import ChangePwdDialog from './components/ChangePwdDialog';
import 'ant-design-vue/dist/antd.css';
import { initViewport } from '@lego/viewport';
initViewport(1280);
// installPassport();
console.log('是否院端环境: ', isInHospEnv);

const app = createApp(App);
export const themeKey = Symbol('theme');
export const layoutKey = Symbol('layout');

// 全局注册api，在.vue中通过getCurrentInstance().appContext.config.globalProperties.http 获取
// app.config.globalProperties.http = http;

app.use(router)
  .use(ChangePwdDialog);
// bootstrap app by function that has configged theme and layout which have already get by api.
initAppConfig<IAppConf>(app, {themeKey, layoutKey});
// .mount('#app');
